import { motion } from 'framer-motion';

const ClientsSection = () => {
  const clients = [
    {
      name: 'Cinemagica Producciones',
      logo: 'https://static.readdy.ai/image/76bdc5cf9f6b144760a23d447c3fb67d/2eed85c8f6f80bdc6a935d676b9ff704.jpeg',
    },
    {
      name: 'Still Pool',
      logo: 'https://static.readdy.ai/image/76bdc5cf9f6b144760a23d447c3fb67d/f2476e2e5f376b062afc41bf5269d1cf.jpeg',
    },
    {
      name: 'Branding Over the Top (Sudaca)',
      logo: 'https://static.readdy.ai/image/76bdc5cf9f6b144760a23d447c3fb67d/ba3686ec65373aa28b7c02a6bd2618ee.png',
    },
  ];

  return (
    <section className="py-20 bg-gray-light">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-sm text-gray-medium uppercase tracking-widest mb-2">
            Empresas que confían en Bala Corp
          </p>
        </motion.div>

        {/* Clients Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {clients.map((client, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              whileHover={{ scale: 1.05, transition: { duration: 0.3 } }}
              className="bg-white rounded-xl p-8 flex items-center justify-center h-48 shadow-sm hover:shadow-xl hover:border-2 hover:border-primary-yellow transition-all duration-300 cursor-pointer group"
            >
              <div className="w-40 h-40 flex items-center justify-center">
                <img
                  src={client.logo}
                  alt={client.name}
                  className="w-full h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
